import { createStore } from "redux"
import reducer from "../reducers"

const initialState = {
    currentRecipe: {}
}

export const store = createStore(reducer, initialState)